import React from "react";
import { useRouter } from "@src/lib/router";
import { useDispatch, useSelector } from "react-redux";
import ContentHome from "@src/components/Tabs/Content/components/ContentHome";
import TrialContent from "@src/components/Tabs/Content/components/TrialContent/index";
import usePageHeading from "@src/customHooks/usePageHeading.js";
import { safeJsonParse } from "@src/utils/safeJsonParse";

const CourseFolder = () => {
  // NEXTJS ROUTER
  const router = useRouter();

  const isTrialContent =
    (router.query.isTrialContent &&
      safeJsonParse(router.query.isTrialContent, {
        source: "FolderPage [router.query.isTrialContent]",
        fallback: 0,
      })) ||
    0;

  // REDUX DISPATCH
  const dispatch = useDispatch();

  // FETCHING CURRENT FOLDER NAME FROM REDUCER
  const currentFolderName = useSelector(
    (state) =>
      state?.courseContentReducer?.currentFolderGET_COURSE_CONTENT?.folderName
  );

  // SETTING PAGE TITLE
  usePageHeading({ heading: currentFolderName });

  if (isTrialContent) {
    return (
      <TrialContent
        folderId={router?.query?.folderId}
        folderRoute
      />
    );
  }

  return (
    <ContentHome
      folderId={router?.query?.folderId}
      folderRoute
    />
  );
};

CourseFolder.getLayoutProps = () => ({
  accent: true,
  blockHeader: true,
});


export default CourseFolder;
